import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";
import { useAsync } from "../lib/useAsync";
import { api } from "../lib/api";

export const REVIEW_AI_ENTITLEMENT = "review_ai.enabled";

export function hasReviewAiEntitlement(
  entitlements: { key: string; status: string }[] | null | undefined,
): boolean {
  return entitlements?.some(
    (entitlement) =>
      entitlement.key === REVIEW_AI_ENTITLEMENT && ["ALLOWED", "TRIAL"].includes(entitlement.status),
  ) ?? false;
}

export function ReviewGuard({ children }: { children: ReactNode }) {
  const { activeOrg } = useAuth();
  const navigate = useNavigate();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (await api.entitlements(orgId)).entitlements, [orgId]);

  if (state.loading) return <LoadingState label="Checking your Review AI access…" />;
  if (!hasReviewAiEntitlement(state.data)) {
    return <EntitlementDeniedState product="Review AI" onUpgrade={() => navigate("/pricing")} />;
  }
  return <>{children}</>;
}
